import { COMPUTER_HAPPY_EVENT } from '#pplx/frontend/apps/ask/computer/branding/ComputerHomeSpinner.js';
import { useEffect, useRef } from 'react';
export function useHappyDispatch(isComputer, value) {
    const dispatchEnabled = useRef(true);
    const timeoutRef = useRef(undefined);
    const prevValueRef = useRef(value);
    useEffect(() => {
        if (isComputer && value.length > 0 && value !== prevValueRef.current) {
            prevValueRef.current = value;
            clearTimeout(timeoutRef.current);
            if (dispatchEnabled.current) {
                document.dispatchEvent(new Event(COMPUTER_HAPPY_EVENT));
                dispatchEnabled.current = false;
            }
            timeoutRef.current = setTimeout(() => (dispatchEnabled.current = true), 5000);
        }
        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, [isComputer, value]);
}
//# sourceMappingURL=ComputerAnimatedLockupShared.js.map